module.exports = __webpack_public_path__ + "img/collection-weddingRingsFinishes.2a72a84.jpg";